import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Button,
  Chip,
  Stack,
} from "@mui/material";
import { useRef, useEffect } from "react";
import { getMonthDayFromWeek } from "../../utils/dateHelpers";

const LeapDialog = ({ open, onClose, previousLeapId, leaps }) => {
  const listRef = useRef(null);

  useEffect(() => {
    if (!open || !previousLeapId) return;

    const handle = requestAnimationFrame(() => {
      const el = document.getElementById(`leap-${previousLeapId}`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });

    return () => cancelAnimationFrame(handle);
  }, [open, previousLeapId]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      scroll="paper"
    >
      <DialogTitle>Development Leaps</DialogTitle>

      <DialogContent
        dividers
        ref={listRef}
        sx={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <List>
          {leaps?.map((leap) => {
            const { years, months, days } = getMonthDayFromWeek(leap.week);

            const ageLabel = years
              ? `${years} y, ${months} mo, ${days} d`
              : `${months} mo, ${days} d`;

            return (
              <ListItem
                key={leap.id}
                id={`leap-${leap.id}`}
                alignItems="flex-start"
                sx={{
                  backgroundColor:
                    leap.id === previousLeapId ? "#e9f5f1" : "transparent",
                  borderRadius: 1,
                  mb: 1,
                }}
              >
                <ListItemText
                  primary={
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <span
                        style={{
                          fontWeight:
                            leap.id === previousLeapId ? "bold" : "normal",
                        }}
                      >
                        {leap.title}
                      </span>
                      <Chip
                        label={`Week ${leap.week} (${ageLabel})`}
                        size="small"
                      />
                    </Stack>
                  }
                  secondary={
                    <span
                      dangerouslySetInnerHTML={{ __html: leap.description }}
                    />
                  }
                />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          variant="outlined"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeapDialog;
